import { j as e, c as n } from "../../utils-BdNIfrGQ.js";
import o, { useState as k } from "react";
import { a as R } from "../../Button-CzIiGCVn.js";
import { D as l } from "../../Div-spVpsZsH.js";
import { F as d } from "../../Flex-BA9xHq_p.js";
import { n as z } from "../../normalize-spacing-DY0KSpr_.js";
import { H as D } from "../../H2-CGvOaVnq.js";
import { P as C } from "../../Paragraph-Cpgi01iq.js";
import { c as S } from "../../index-Di82Y7n3.js";
import { N as B } from "../../NavLink-D9Qfouy1.js";
import { X as F } from "../../x-BXShoIAM.js";
const m = S("relative w-full", {
  variants: {
    color: {
      success: "bg-success-light text-success-foreground-dark",
      info: "bg-info-light text-info-foreground-dark",
      warning: "bg-warning-light text-warning-foreground-dark",
      destructive: "bg-destructive-light text-destructive-foreground-dark"
    },
    variant: {
      default: "rounded-lg py-4 px-5",
      banner: "py-2 px-5"
    }
  },
  defaultVariants: {
    color: "success",
    variant: "default"
  }
}), f = o.forwardRef(({ color: s, ...r }) => /* @__PURE__ */ e.jsx("div", { role: "alert", className: n(m({ color: s })), ...r }));
f.displayName = "AlertContainer";
const x = o.forwardRef(({ color: s, variant: r, ...t }, a) => (
  // @ts-expect-error todo - H2 throws a TS error about children
  /* @__PURE__ */ e.jsx(D, { ref: a, size: r === "banner" ? "sm" : "md", color: s, ...t })
));
x.displayName = "AlertTitle";
const p = o.forwardRef(({ color: s, variant: r, ...t }, a) => /* @__PURE__ */ e.jsx(
  C,
  {
    ref: a,
    size: "sm",
    type: r === "banner" ? "small" : void 0,
    color: s,
    ...t
  }
));
p.displayName = "AlertDescription";
const u = o.forwardRef(
  ({ children: s, ...r }, t) => /* @__PURE__ */ e.jsx(l, { className: "ml-auto", children: /* @__PURE__ */ e.jsx(B, { id: "alert-action", variant: "inline", ref: t, ...r, children: s }) })
);
u.displayName = "AlertAction";
const I = ({
  color: s,
  variant: r,
  icon: t,
  title: a,
  description: h,
  spacing: g,
  dismissible: j,
  action: c,
  onDismiss: A,
  children: N,
  ...v
}) => {
  const [w, b] = k(!0), y = w ? "" : "hidden", i = r === "banner";
  return /* @__PURE__ */ e.jsx(
    f,
    {
      className: n(m({ color: s, variant: r }), z(g), y),
      ...v,
      children: /* @__PURE__ */ e.jsxs(d, { className: i ? "items-center" : void 0, children: [
        /* @__PURE__ */ e.jsx(l, { className: i ? "flex" : void 0, children: t }),
        /* @__PURE__ */ e.jsxs(
          l,
          {
            className: n(
              "ml-4 mr-auto w-full",
              i && "flex flex-wrap items-baseline gap-x-4"
            ),
            children: [
              a && /* @__PURE__ */ e.jsx(x, { variant: r, children: a }),
              /* @__PURE__ */ e.jsxs(d, { className: "flex-col justify-between", gap: "4", children: [
                /* @__PURE__ */ e.jsx(p, { variant: r, children: h }),
                N,
                c && /* @__PURE__ */ e.jsx(u, { children: c })
              ] })
            ]
          }
        ),
        j && /* @__PURE__ */ e.jsx(l, { className: "h-fit", children: /* @__PURE__ */ e.jsx(
          R,
          {
            variant: "ghost",
            size: i ? "icon-sm" : "icon",
            "aria-label": "Dismiss alert",
            onClick: () => {
              b(!1), A?.();
            },
            children: /* @__PURE__ */ e.jsx(F, { size: 16, strokeWidth: 2 })
          }
        ) })
      ] })
    }
  );
};
export {
  I as default
};
